module.exports = __webpack_public_path__ + "img/skip-end-circle.221a703d.svg";